<div class="rg-page-header">
  <div>
    <h3 class="fw-bold mb-1">Settings</h3>
    <p class="text-muted mb-0">
      Configure RiskGuard Licensing system defaults.
    </p>
  </div>
</div>

<div class="container-fluid p-4">
  <div class="row g-3">
    <div class="col-12 col-xl-6">
      <div class="card border-0 shadow-sm rg-card">
        <div class="card-header bg-white">
          <strong>Licence Defaults</strong>
        </div>

        <div class="card-body">
          <div class="mb-3">
            <label class="form-label">Default Licence Duration Days</label>
            <input type="number" class="form-control" value="365">
          </div>

          <div class="mb-3">
            <label class="form-label">Default Grace Period Days</label>
            <input type="number" class="form-control" value="30">
          </div>

          <button class="btn btn-primary" disabled>
            Save Licence Defaults
          </button>
          <small class="text-muted d-block mt-2">
            Global licence defaults are not exposed by the current API.
          </small>
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-6">
      <div class="card border-0 shadow-sm rg-card">
        <div class="card-header bg-white">
          <strong>Reminder Defaults</strong>
        </div>

        <div class="card-body">
          <div class="mb-3">
            <label class="form-label">Default Reminder Days</label>
            <input type="text" class="form-control" value="30,14,7,3,1">
            <small class="text-muted">Comma-separated days before licence expiry.</small>
          </div>

          <button class="btn btn-primary" disabled>
            Save Reminder Defaults
          </button>
          <small class="text-muted d-block mt-2">
            Reminder defaults are configured per organization.
          </small>
        </div>
      </div>
    </div>
  </div>
</div>
